/* eslint-disable no-undef */
/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { routeColors } from '../../constants/index';
import styles from './styles';
import theme from '../../theme/theme';

const {
  Icons: {
    general: { routebarArrow },
  },
} = theme;

const { trafficColor } = routeColors;
const routeScreens = () => ['/routes'].includes(window.location.pathname);

const RouteBar = ({ classes, addStopInProgress, route: { distanceTraveled, trafficArray } }) => (
  <React.Fragment>
    <div className={classes.progress__container}>
      <div className={classes.progress__bar}>
        <span
          style={{
            width: `${distanceTraveled * 100}%`,
            backgroundColor: trafficColor('currentDistance'),
          }}
        />
        <span className={classes.start__circle}>
          <img className={classes.start__icon} src={routebarArrow} alt="Start Icon" />
        </span>
        {trafficArray.map(route => (
          <span
            style={{
              width: `${route.distance * 100}%`,
              backgroundColor: trafficColor(route.condition),
            }}
          />
        ))}
        {addStopInProgress && !routeScreens() ? (
          <span className={classes.end__circle__white}>
            <span className={classes.end__circle__blue}>
              <span className={classes.letter__a}>A</span>
            </span>
          </span>
        ) : null}

        {addStopInProgress && routeScreens() ? (
          <span className={classes.end__circle__white2}>
            <span className={classes.end__circle__blue}>
              <span className={classes.letter__a}>A</span>
            </span>
          </span>
        ) : null}
      </div>
    </div>
  </React.Fragment>
);

RouteBar.propTypes = {
  classes: PropTypes.object.isRequired,
  route: PropTypes.object.isRequired,
  addStopInProgress: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ poi }) => ({
  addStopInProgress: poi.stops_inprogress,
});

const mapDispatchToProps = () => ({});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(RouteBar),
);
